import { Pause, Play } from 'lucide-react';

import { Button } from '@/components/Button/Button';
import { Tooltip } from '@/components/Tooltip/Tooltip';

import styles from './ControlBar.module.css';

interface PlayPauseButtonProps {
  isPlaying: boolean;
  onToggle: () => void;
  /** Why it cannot be pressed yet, while the player loads. */
  unavailableReason?: string;
}

export function PlayPauseButton({
  isPlaying,
  onToggle,
  unavailableReason,
}: PlayPauseButtonProps) {
  const label = isPlaying ? 'Pause' : 'Play';
  const Icon = isPlaying ? Pause : Play;

  // aria-disabled, not disabled, as ConfusedButton does: a disabled button
  // takes no pointer or focus, so the tooltip saying why could never show.
  return (
    <Tooltip content={unavailableReason ?? label}>
      <Button
        aria-disabled={unavailableReason ? 'true' : undefined}
        aria-label={label}
        className={styles.iconButton}
        iconOnly
        onClick={unavailableReason ? undefined : onToggle}
        size="small"
        title={unavailableReason}
        variant="ghost"
      >
        <Icon aria-hidden="true" className={styles.controlIcon} size={20} />
      </Button>
    </Tooltip>
  );
}
